// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"7e874b9d","513":"55a2c903","703":"547aa86c","787":"395c4440"}[chunkId] + ".chunk.js";
};